import { css } from '@emotion/react'

/** first text letter will be capital */
export const firstLetterCap = css`
    *:first-letter {text-transform: uppercase}
`